import { render, staticRenderFns } from "./MedicineItem.vue?vue&type=template&id=6eb038c1&scoped=true&"
import script from "./MedicineItem.vue?vue&type=script&lang=js&"
export * from "./MedicineItem.vue?vue&type=script&lang=js&"
import style0 from "./MedicineItem.vue?vue&type=style&index=0&id=6eb038c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb038c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VListItemContent,VListItemSubtitle,VListItemTitle,VRow})
